import { useCallback, useState } from 'react';

const KEY_PREFIX = 'moftakilab:gridDock:';

/**
 * Persisted dock/undock preference for a grid's frozen lead columns
 * (BUG-2026-0159 follow-up). On smaller screens the frozen pane can eat most
 * of the viewport width, so users can unpin it; the choice sticks per grid.
 * Default: docked.
 */
export function useFrozenDock(gridId: string) {
  const storageKey = `${KEY_PREFIX}${gridId}`;
  const [docked, setDocked] = useState<boolean>(() => {
    try { return localStorage.getItem(storageKey) !== 'undocked'; } catch { return true; }
  });
  const toggleDock = useCallback(() => {
    setDocked((prev) => {
      const next = !prev;
      try { localStorage.setItem(storageKey, next ? 'docked' : 'undocked'); } catch { /* private mode */ }
      return next;
    });
  }, [storageKey]);
  return { docked, toggleDock };
}
